import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Title;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { Tooltip } from '@instructure/ui-tooltip';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import { withStyleOverrides } from '@instructure/quiz-common';
var DISPLAY_TOOLTIP_LIMIT = 80;
export var Title = (_dec = withStyleOverrides(generateStyle, null), _dec(_class = (_Title = /*#__PURE__*/function (_Component) {
  function Title() {
    _classCallCheck(this, Title);
    return _callSuper(this, Title, arguments);
  }
  _inherits(Title, _Component);
  return _createClass(Title, [{
    key: "renderTitle",
    value: function renderTitle() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.title;
      return jsx("div", {
        css: this.props.styles.itemBody
      }, jsx(Text, {
        color: "primary"
      }, title));
    }
  }, {
    key: "render",
    value: function render() {
      var title = this.props.title;

      // Shorten title if necessary
      if (title.length > DISPLAY_TOOLTIP_LIMIT) {
        var truncatedTitle = "".concat(title.substring(0, DISPLAY_TOOLTIP_LIMIT), "...");
        return jsx(AccessibleContent, {
          alt: title
        }, jsx(Tooltip, {
          renderTip: title,
          color: "primary"
        }, this.renderTitle(truncatedTitle)));
      }
      return this.renderTitle();
    }
  }]);
}(Component), _defineProperty(_Title, "displayName", 'Title'), _defineProperty(_Title, "componentId", "Quizzes".concat(_Title.displayName)), _defineProperty(_Title, "propTypes", {
  title: PropTypes.string.isRequired,
  styles: PropTypes.object
}), _Title)) || _class);
export default Title;